import { type ReactNode } from 'react';

import type { RegisMessage } from 'ui/molecules/RegisChat/RegisChat.types';

import styles from './InvestmentScreeningRegis.module.scss';

const Cite = ({ children }: { children: ReactNode }) => <span className={styles.cite}>{children}</span>;

export const REGIS_MESSAGES: RegisMessage[] = [
  {
    from: 'user',
    content: 'Shortlist UK precision engineering companies, £20–60M turnover, no sponsor on the register.',
  },
  {
    from: 'assistant',
    content: (
      <>
        <b>41 companies</b> match. Turnover £20,000,000–£60,000,000 on last filed accounts, activity SIC 2562 · 2599 ·
        2811, majority privately held with <b>no PE or VC name on the shareholder register</b>. Ownership chain and
        officer screening are resolved for each — three carry a director also appointed at a company under an active
        court judgment.
        <span className={styles.cites}>
          <Cite>Companies House · SIC 2562</Cite>
          <Cite>Filed accounts · FY2025</Cite>
          <Cite>Shareholder register · live</Cite>
        </span>
      </>
    ),
  },
];
